export class PointValue {
    static format (value, programLabels) {
        const formattedValue = value.toLocaleString("pt-br", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        const programLabel = programLabels?.POINT || {
            singular: 'ponto',
            plural: 'pontos',
        };

        const sanitizedValue = formattedValue.replace(/\s/g, ' ');
      
        return value > 1
            ? `${sanitizedValue} ${programLabel.plural}`
            : `${sanitizedValue} ${programLabel.singular}`;
    }
}